<template>
  <section>
    <!-- Listing Header -->
    <historical-header :norms="norms" @search="search" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <z-table
        :value="vo2assessments"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <!-- <th scope="row" class="z-column-80">
            {{ props.row.id }}
          </th> -->
          <td>{{ formatDate(props.row.created_at) }}</td>
          <td>{{ props.row.assessmentType }}</td>
          <td>{{ props.row.testType }}</td>
          <td class="z-column-100-right">
            {{ formatNumber(props.row.vo2, 1) }}
          </td>
          <td class="z-column-140-right">
            {{ calcDuration(props.row.duration) }}
          </td>
          <td class="z-column-100-right">{{ props.row.lastHR }}</td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import HistoricalHeader from './heart-monitor-historical-header'
export default {
  name: 'heart-monitor-historical',
  components: {
    ZTable,
    HistoricalHeader,
  },
  data() {
    return {
      page: 1,
      isLoading: false,
    }
  },
  async mounted() {
    this.isLoading = false
    this.setPager({
      name: 'page',
      value: 1,
    })
    this.setPager({
      name: 'search',
      value: '',
    })
    await this.search()
  },
  computed: {
    ...mapGetters('usercardio', ['member']),
    ...mapGetters('measurements', ['vo2assessments', 'pager']),
    ...mapGetters('configuration', ['assessmentNorms']),
    tableColumns() {
      return [
        // {
        //   field: 'id',
        //   label: 'Id',
        //   sortable: true,
        //   class: 'z-column-80',
        // },
        {
          field: 'created_at',
          label: 'Date',
          sortable: true,
          class: 'z-column-200',
        },
        { field: 'assessmentType', label: 'Type', sortable: true },
        { field: 'testType', label: 'Name', sortable: true },
        {
          field: 'vo2',
          label: 'VO2',
          sortable: false,
          class: 'z-column-center',
        },
        {
          field: 'duration',
          label: 'Duration (mins.)',
          sortable: false,
          class: 'z-column-center',
        },
        {
          field: 'lastHR',
          label: 'HR',
          sortable: false,
          class: 'z-column-center',
        },
      ]
    },
    memberAge() {
      let _age = null
      if (this.member) {
        _age = parseInt(this.member.age)
      }
      return _age
    },
    memberGender() {
      let _gender = null
      if (this.member) {
        _gender = this.member.gender.toLowerCase()
      }
      return _gender
    },
    normsMen() {
      let _data = null
      if (this.assessmentNorms) {
        let found = this.assessmentNorms.find((x) => x.Value === 'Men')
        if (found) {
          _data = JSON.parse(found.TextValue)
        }
      }
      return _data
    },
    normsWomen() {
      let _data = null
      if (this.assessmentNorms) {
        let found = this.assessmentNorms.find((x) => x.Value === 'Women')
        if (found) {
          _data = JSON.parse(found.TextValue)
        }
      }
      return _data
    },
    norms() {
      let _data = []
      let found = null
      // determine Gender array to use
      if (this.memberGender === 'female') {
        found = this.normsWomen.find(
          (x) =>
            parseInt(this.memberAge) >= parseInt(x.age.start) &&
            parseInt(this.memberAge) <= parseInt(x.age.end)
        )
      } else {
        found = this.normsMen.find(
          (x) =>
            parseInt(this.memberAge) >= parseInt(x.age.start) &&
            parseInt(this.memberAge) <= parseInt(x.age.end)
        )
      }
      if (found) {
        for (var i = 0; i < found.age.scale.length; i++) {
          // set up Norms Scale
          let scale = ''
          if (found.age.scale[i].start === 0) {
            scale = `< ${found.age.scale[i].end}`
          } else if (found.age.scale[i].end === 9999) {
            scale = `> ${found.age.scale[i].start}`
          } else {
            scale = `${found.age.scale[i].start} - ${found.age.scale[i].end}`
          }
          _data.push({
            name: found.age.scale[i].name,
            scale: scale,
          })
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('measurements', [
      'getVO2assessment',
      'getVO2assessments',
      'setPager',
    ]),
    formatDate(value) {
      return moment(value).format('MM/DD/YYYY hh:mm a')
    },
    formatNumber(value, places) {
      let results = ''
      places = places ? parseInt(places) : 0
      if (value) {
        results = parseFloat(value).toFixed(places)
      }
      return results
    },
    calcDuration(value) {
      let results = 0
      if (value) {
        results = (value / 60).toFixed(1)
      }
      return results
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        await this.getVO2assessments({
          userId: this.member.id,
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    async viewAssessment(row) {
      await this.getVO2assessment(row.id)
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
</style>
